import { render, staticRenderFns } from "./mb-product-box.vue?vue&type=template&id=0ac57b90&"
import script from "./mb-product-box.vue?vue&type=script&lang=js&"
export * from "./mb-product-box.vue?vue&type=script&lang=js&"
import style0 from "./mb-product-box.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports